import Vue from "vue";
import VueRouter from "vue-router";
import Content from "../views/Content.vue";
import Background from "../views/Background.vue";
import Imprint from "../views/Imprint.vue";
import Story from "../views/Story.vue";
import stories from "@/models/stories";

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL
});

Vue.use(VueRouter);

(async () => {
  const routes = [];
  let metadataJSON = [];

  try {
    const metadataFile = await fetch(`${process.env.BASE_URL}metadata.json`);
    metadataJSON = await metadataFile.json();
  } catch (e) {
    console.log("Could not retrieve metadata.json.");
  }

  stories.items = metadataJSON;

  const menuRoutes = [
    {
      path: "/",
      name: "Content",
      component: Content
    },
    {
      path: "/background",
      name: "Background",
      component: Background
    },
    {
      path: "/imprint",
      name: "Imprint",
      component: Imprint
    }
  ];

  for (const route of menuRoutes) routes.push(route);

  for (const story of stories.items)
    routes.push({
      path: "/" + story.route,
      name: "Story-" + story.route,
      component: Story,
      props: {
        mapURL: story.mapURL
      }
    });

  router.addRoutes(routes);
})();

export default router;
